/**
 * How a document names the parties on it. A party with no legal name stores
 * `null` (older rows may hold a blank string), so every renderer, snapshot
 * builder and Bill view resolves a name through these functions rather than
 * hand-writing a `??` / `||` chain. Pure, so the backend PDF and the Bill
 * screen cannot disagree about a name.
 */
/** The trimmed value, or `null` when it is absent or blank. The one place "blank means absent" lives. */
export function heldName(value) {
    const trimmed = value?.trim();
    return trimmed ? trimmed : null;
}
/** A recipient (client or supplier): the held legal name, else the everyday name. */
export function documentPartyName(party) {
    return heldName(party.legalName) ?? party.everydayName;
}
/**
 * The sender (the firm): the held legal name, else the trading name, else the
 * account name. Never blank, provided the account name is not.
 */
export function senderDocumentName(party) {
    return heldName(party.legalName) ?? heldName(party.tradingName) ?? party.accountName;
}
